import { render, staticRenderFns } from "./print_waiFa.vue?vue&type=template&id=8c0f7a62&scoped=true&"
import script from "./print_waiFa.vue?vue&type=script&lang=js&"
export * from "./print_waiFa.vue?vue&type=script&lang=js&"
import style0 from "./print_waiFa.vue?vue&type=style&index=0&id=8c0f7a62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0f7a62",
  null
  
)

export default component.exports